import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormikContext } from 'formik'

import { Loader } from '@/components/loaders/Loader'
import { generateChecklistDescription } from '@/reducers/playbooks/playbook.actions'

export const ChecklistDescriptionField = ({ committedPrompt }) => {
  const dispatch = useDispatch()
  const { values, setFieldValue } = useFormikContext()
  const [isGenerating, setIsGenerating] = useState(false)
  const lastDescribedPrompt = useRef(null)

  useEffect(() => {
    const generateDescription = async () => {
      setIsGenerating(true)
      try {
        const result = await dispatch(generateChecklistDescription(committedPrompt))
        if (result) {
          setFieldValue('description', result)
        }
      } finally {
        setIsGenerating(false)
      }
    }

    if (committedPrompt?.trim() && committedPrompt !== lastDescribedPrompt.current) {
      lastDescribedPrompt.current = committedPrompt
      generateDescription()
    }
  }, [committedPrompt])

  if (!values.description?.trim() && !isGenerating) {
    return null
  }

  return (
    <div className="mt">
      <h4>Description</h4>
      <div className="form-caption mb">Auto generated description shown in the agent app.</div>
      {isGenerating ? (
        <div className="flex-align-center small-gap">
          <Loader size="small" />
          <span>Generating description...</span>
        </div>
      ) : (
        <div className="pre-wrap">{values.description}</div>
      )}
    </div>
  )
}
